<template>
  <div class="imo-dialog">
    <el-dialog :title="imoType != 3 ? '查询成功' : '查询失败'" :visible.sync="visible" :before-close="closeDialog" width="720px" :close-on-click-modal="false">
      <div v-if="imoType != 3">
        <div style="margin-bottom: 24px;">查询结果仅供参考，请以东方海外官网信息为准！</div>
        <div>
          <WTable :WTableOpts="WTableOpts">
            <template #imo="{ row }">
              <div class="flex">
                <div class="table-content">{{ row.imo }}</div>
                <div class="content-center" v-if="row.imo" @click="copy(row.imo)"><i class="iconfont icon-fuzhi"></i></div>
              </div>
            </template>
            <template #operation="{ row }">
              <div class="table-btn-box">
                <el-link type="primary" :underline="false" @click="enterImo(row)">确认选择</el-link>
              </div>
            </template>
          </WTable>
        </div>
      </div>
      <div class="content-center-column" v-else>
        <div class="content-center">
          <i style="font-size: 40px; margin-bottom: 20px; color: #eb0101" class="el-icon-error"></i>
        </div>

        <div style="color: #eb0101; font-weight: bold">
          请手动输入IMO编号，或联系客服人员协助您查询确认
        </div>
        <div>参考网址：</div>
        <div>
          东方海外官网：www.oocl.com
          <span style="margin-left: 10px; color: #2d8cf0; cursor: pointer" @click="copy('www.oocl.com')">复制</span>
        </div>
        <div>
          船讯网：www.shipxy.com
          <span style="margin-left: 10px; color: #2d8cf0; cursor: pointer" @click="copy('www.shipxy.com')">复制</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "Imo",
  props: {
    visible: Boolean,
    imoData: {
      type: Object,
      default: () => {}
    },
    imoType: String
  },
  data() {
    return {
      WTableOpts: {
        data: [],
        tableAttrs: { border: false },
        tableColAttrs: [
          { prop: 'vesselName', label: '船名'},
          { prop: 'imo', label: '参考IMO号', slotName: 'imo'},
          { prop: '', label: '操作', slotName: 'operation'}
        ]
      },
    }
  },
  created() {
    this.WTableOpts.data = [{
      vesselName: this.imoData.vesselName ? this.imoData.vesselName : '',
      imo: this.imoData.imo ? this.imoData.imo : '',
    }]
  },
  methods: {
    // 确认选择
    enterImo(row){
      this.$emit('enterImo', row)
      this.$emit('closeDialog')
    },
    // 复制
    copy(e){
      this.$copyText(e)
			this.$message({
				type: 'success',
				message: '复制成功!'
			})
    },
    // 关闭
    closeDialog(){
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped lang="less">
.imo-dialog {
  color: #333333;
  font-size: 14px;

  .el-button {
    height: 32px;
  }
  .table-content {
    max-width: 290px;
    margin-right: 10px;
  }
  .max-200 {
    max-width: 200px;
  }

  .icon-fuzhi {
    color: #1170eb;
    font-size: 12px;
    cursor: pointer;
  }
}
</style>